import React from 'react'

const VisaCardIocn = (props:any) => {
  return (
    <svg width={35} height={13} fill="none" {...props}>
    <path
      fill="#1434CB"
      d="M13.29 1.032 8.705 11.964h-2.99L3.463 3.239c-.137-.538-.255-.735-.673-.96C2.11 1.91.986 1.563 0 1.348l.067-.317H4.88c.612 0 1.165.408 1.303 1.115l1.19 6.326 2.945-7.441h2.971Zm11.713 7.362c.013-2.885-3.99-3.044-3.963-4.333.01-.392.383-.81 1.2-.915.404-.053 1.522-.093 2.789.489l.495-2.319A7.57 7.57 0 0 0 22.88.831c-2.796 0-4.763 1.486-4.78 3.615-.018 1.573 1.404 2.452 2.476 2.975 1.103.536 1.473.88 1.468 1.358-.008.733-.879 1.057-1.694 1.07-1.422.022-2.246-.385-2.904-.69l-.512 2.394c.66.303 1.881.567 3.145.582 2.973 0 4.916-1.467 4.925-3.74Zm7.381 3.57H35L32.716 1.032h-2.414c-.543 0-1 .315-1.203.802l-4.244 10.13h2.97l.59-1.634h3.628l.341 1.634ZM29.23 8.09l1.489-4.105.857 4.105h-2.346ZM17.33 1.032l-2.34 10.932h-2.829l2.341-10.932h2.828Z"
    />
  </svg>
  )
}

export default VisaCardIocn